export default {
  root: ({ props, context }) => ({
    class: [
      'relative shrink-0',
      // Spacing
      'py-0 px-2 md:px-4 xl:px-8',
      // Colors and Conditions
      'outline-transparent',
      'hover:border-surface-500',
      {
        'border-solid border-b-[1.5px] border-transparent dark:border-surface-700': !context.active,
        'bg-surface-0 dark:bg-surface-900': !context.active,
        'font-light text-surface-600 dark:text-surface-0/80': !context.active,
        'dark:bg-surface-900': context.active,
        'text-surface-800': context.active,
        'opacity-60 cursor-default user-select-none select-none pointer-events-none': props == null ? void 0 : props.disabled
      },

      // Transitions
      'transition-all duration-200',
      // Misc
      'cursor-pointer select-none whitespace-nowrap',
      'user-select-none'
    ]
  })
}